<script setup>
  import VueQrcode from "vue-qrcode";

  defineOptions({
    name: "ComponentQrCode",
    components: {VueQrcode},
  });

  defineProps({
    value: {
      type: String,
      required: true,
    },
  });

  defineEmits(["change"]);
</script>

<template>
  <vue-qrcode
    class="max-w-44"
    type="image/jpeg"
    :scale="8"
    :margin="2"
    :color="{dark: '#000000ff', light: '#ffffffff'}"
    :data-test="getTestId('qr-code')"
    :value="value"
    @change="$emit('change', $event)"
  />
</template>
